import useOkhatiAiSettings, { isOkhatiAiReady } from "./useOkhatiAiSettings";

function useHasTranscriptionEnabled(): {
  isTranscriptionEnabled: boolean;
  hasTranscriptionApiKey: boolean;
  isOkhatiAiConfigured: boolean;
} {
  const settings = useOkhatiAiSettings();

  return {
    isTranscriptionEnabled: settings.enabled,
    hasTranscriptionApiKey: Boolean(settings.transcriptionApiKey),
    isOkhatiAiConfigured: isOkhatiAiReady(settings)
  };
}

export default useHasTranscriptionEnabled;
